import { makeStyles } from "@material-ui/core";

export const useDialogStyles = makeStyles((theme) => ({
  stepContent: {
    minHeight: '250px',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
  },
  roleCard: {
    padding: '16px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '2px solid transparent',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
  },
  roleCardSelected: {
    borderColor: theme.palette.primary.main,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  dialogActions: {
    padding: theme.spacing(6),
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  button: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5, 3),
    flex: 1,
    maxWidth: '200px',
    '&:hover': {
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    },
  },
  singleButton: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5, 3),
    minWidth: '120px',
    '&:hover': {
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    },
  },
  dialogTitle: {
    padding: theme.spacing(6),
  },
  dialogContent: {
    padding: theme.spacing(0, 3, 3, 3),
  },
}));
